import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { FormControl } from '@angular/forms';
import { Observable, Subscription, debounceTime, filter, map } from 'rxjs';
import { SubSectionData } from 'src/app/model/help';
import { Lang } from 'src/app/model/lang';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectHelpGuestLoading, selectHelpSearchList } from 'src/app/store/help/help.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { LINK_CONTACT_US_EN, LINK_CONTACT_US_IT, LINK_CONTACT_US_ES, LINK_CONTACT_US_DE, LINK_CONTACT_US_PL, LINK_CONTACT_US_NL, LINK_CONTACT_US_FR, LINK_SUPPORT_INTERCOM_EN, LINK_SUPPORT_INTERCOM_IT, LANGUAGES, DEFAULT_LANG, CLIENTS_LANGUAGES } from 'src/app/conf/languages';
import { ActivatedRoute } from '@angular/router';
import * as UserActions from 'src/app/store/user/user.actions';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-helper-view-guest-clients',
	templateUrl: './helper-view-guest-clients.component.html',
})

export class HelperViewGuestClientsComponent  implements OnInit, OnDestroy {
	@Input() appid: string;

	helpSearchList: SubSectionData[];
	helpSearchList$: Observable<SubSectionData[] | undefined>;
	helpSearchListSub: Subscription | undefined;

	currentLang: Lang = DEFAULT_LANG;
	currentLang$: Observable<Lang> = new Observable();
	currentLangSub: Subscription | undefined;

	loading: boolean = true;
	helpGuestLoading: boolean = false;
	helpGuestLoading$: Observable<boolean | undefined>;
	helpGuestLoadingSub: Subscription | undefined;

	// helpGuestSearchLoading: boolean = false;
	// helpGuestSearchLoading$: Observable<boolean | undefined>;
	// helpGuestSearchLoadingSub: Subscription | undefined;

	searchFilter: FormControl = new FormControl('');
	filter: string = '';
	filterSub: Subscription | undefined;

	langParam: string = 'en';
	connectLanguage: Lang = DEFAULT_LANG;
	clientLanguage: Lang = DEFAULT_LANG;

	roleUser: string;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
		){
		this.initSelectors();
	}

	initSelectors(): void{
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.helpSearchList$ = this.store.select(selectHelpSearchList);
		this.helpGuestLoading$ = this.store.select(selectHelpGuestLoading);
		// this.helpGuestSearchLoading$ = this.store.select(selectHelpGuestSearchLoading);
	}

	ngOnInit(): void {
		this.store.dispatch(AuthActions.authLogout());

		const langUrl = this.route.snapshot.queryParamMap.get('language');
		if (langUrl !== undefined && langUrl !== null) {
			this.langParam = langUrl.slice(0,2).toLowerCase();
		}

		this.store.dispatch(UserActions.setCurrentLang({ lang: this.getConnectLang(this.langParam) }));

		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.currentLangSub = this.currentLang$?.pipe(
			filter(lang => !!lang),
		).subscribe((lang) => {
			this.connectLanguage = lang;
			this.clientLanguage = this.getClientLang(this.langParam);
			if (this.filter === '') {
				this.store.dispatch(HelpActions.getHelpGuestLangParam({ appid: this.appid, lang: this.clientLanguage }));
			} else {
				this.store.dispatch(HelpActions.getHelpGuestSearchLangParam({ filter: this.filter, appid: this.appid, lang: this.clientLanguage }));
			}
			this.loading = false;
			this.catchAnalyticsEvent();
		});
		this.helpSearchListSub = this.helpSearchList$.subscribe((helpSearchList) => {
			this.helpSearchList = helpSearchList;
		});
		this.helpGuestLoadingSub = this.helpGuestLoading$?.subscribe(
			(helpGuestLoading) => {
				this.helpGuestLoading = helpGuestLoading;
			}
		);
		// this.helpGuestSearchLoadingSub = this.helpGuestSearchLoading$?.subscribe(
		// 	(helpGuestSearchLoading) => {
		// 		this.helpGuestSearchLoading = helpGuestSearchLoading;
		// 	}
		// );
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.filter = value;
			this.store.dispatch(HelpActions.getHelpGuestSearchLangParam({ filter: this.filter, appid: this.appid, lang: this.clientLanguage }));
		});
	}

	ngOnDestroy(): void {
		this.helpSearchListSub?.unsubscribe();
		this.helpGuestLoadingSub?.unsubscribe();
		// this.helpGuestSearchLoadingSub?.unsubscribe();
	}

	accordionAction(): void {
		const listaFrames = document.getElementsByTagName('iframe');

		for (let index = 0; index <= listaFrames.length; index++) {
			if (listaFrames[index]!== undefined){
					const iframe = listaFrames[index].contentWindow;
					iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}
	}

	catchAnalyticsEvent() {
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventNoAuthLangParam({ eventName: 'custom_page_view', params: { page_title: 'Help', app_id: this.appid, lang: this.clientLanguage.code } }));
		}, 2000);
	}

	getConnectLang(langParam: string): Lang {
		switch (langParam) {
			case 'it': {
				langParam = 'it-IT';
				break;
			}
			case 'es': {
				langParam = 'es-ES';
				break;
			}
			case 'de': {
				langParam = 'de-DE';
				break;
			}
			case 'pl': {
				langParam = 'pl-PL';
				break;
			}
			case 'nl': {
				langParam = 'nl-NL';
				break;
			}
			case 'fr': {
				langParam = 'fr-FR';
				break;
			}
			case 'ru': {
				langParam = 'ru-RU';
				break;
			}
			case 'sk': {
				langParam = 'sk-SK';
				break;
			}
			case 'hu': {
				langParam = 'hu-HU';
				break;
			}
			default: {
				langParam = 'en-US';
				break;
			}
		}
		return LANGUAGES.find(lang => lang.code === langParam);
	}

	getClientLang(langParam: string): Lang {
		switch (langParam) {
			case 'it': {
				langParam = 'it-IT';
				break;
			}
			case 'es': {
				langParam = 'es-ES';
				break;
			}
			case 'de': {
				langParam = 'de-DE';
				break;
			}
			case 'pl': {
				langParam = 'pl-PL';
				break;
			}
			case 'nl': {
				langParam = 'nl-NL';
				break;
			}
			case 'fr': {
				langParam = 'fr-FR';
				break;
			}
			case 'ru': {
				langParam = 'ru-RU';
				break;
			}
			case 'sk': {
				langParam = 'sk-SK';
				break;
			}
			case 'hu': {
				langParam = 'hu-HU';
				break;
			}
			case 'pt': {
				langParam = 'pt-PT';
				break;
			}
			case 'sv': {
				langParam = 'sv-SE';
				break;
			}
			case 'cs': {
				langParam = 'cs-CZ';
				break;
			}
			default: {
				langParam = 'en-US';
				break;
			}
		}
		return CLIENTS_LANGUAGES.find(lang => lang.code === langParam);
	}

	openIntercomSupport() {
		let url = LINK_SUPPORT_INTERCOM_EN;
		switch (this.connectLanguage.code) {
			case 'it-IT': {
				url = LINK_SUPPORT_INTERCOM_IT;
				break;
			}
			default: {
				url = LINK_SUPPORT_INTERCOM_EN;
				break;
			}
		}
		window.open(url, '_blank');
	}

	openNewTabContactUs() {
		let url = LINK_CONTACT_US_EN;
		switch (this.connectLanguage.code) {
			case 'it-IT': {
				url = LINK_CONTACT_US_IT;
				break;
			}
			case 'es-ES': {
				url = LINK_CONTACT_US_ES;
				break;
			}
			case 'de-DE': {
				url = LINK_CONTACT_US_DE;
				break;
			}
			case 'pl-PL': {
				url = LINK_CONTACT_US_PL;
				break;
			}
			case 'nl-NL': {
				url = LINK_CONTACT_US_NL;
				break;
			}
			case 'fr-FR': {
				url = LINK_CONTACT_US_FR;
				break;
			}
			default: {
				url = LINK_CONTACT_US_EN;
				break;
			}
		}
		window.open(url, '_blank');
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	col6HeaderPage(position: string): string {
		return StandardPageLayout.col6HeaderPage(this.screenWidth, position);
	}
}
